import { Component, Output, EventEmitter, Input, ViewEncapsulation } from '@angular/core';
import { slideInFromBottomAnimation } from '../scss/slide-in-from-bottom-animation';

@Component({
  selector: 'app-email-more-actions',
  templateUrl: './email-more-actions.component.html',
  animations: [slideInFromBottomAnimation],
  encapsulation: ViewEncapsulation.None
})
export class EmailMoreActionsComponent {
  @Input()
  hasWrapUps: boolean;

  @Output()
  togglePanel: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  sendAndClose: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  send: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  subjectAndMore: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  transfer: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  wrapUp: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  closeEmail: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  cancelEmail: EventEmitter<any> = new EventEmitter<any>();

  public onTogglePanelClick(): void {
    this.togglePanel.emit();
  }

  public onSendAndCloseClick(): void {
    this.sendAndClose.emit();
  }

  public onSendClick(): void {
    this.send.emit();
  }

  public onSubjectAndMoreClick(): void {
    this.subjectAndMore.emit();
  }

  public onTransferClick(): void {
    this.transfer.emit();
  }

  public onWrapUpClick(): void {
    this.wrapUp.emit();
  }

  public onCloseEmailClick(): void {
    this.closeEmail.emit();
  }

  public onCancelEmailClick(): void {
    this.cancelEmail.emit();
  }
}
